<app-content-shell>
  <app-header mainHeader />
  <app-panel-header panelHeader [title]="'APIs'" />
  <div panelContent></div>
  <div mainContent>
    <app-empty-state
      icon="api"
      title="API Access"
      subtitle="Manage your API keys and integrations."
    />
  </div>
</app-content-shell>
